import { Flex } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { VerificationHistoryTable } from '~/packages/verifications/ui/VerificationHistoryTable';

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();
  return <VerificationHistoryTable organizationId={user.organization.id} />;
};

// Exports
export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="/funding-requests" />;
    }}
  >
    <Flex direction="column" padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}>
      <RouteBase />
    </Flex>
  </RouteErrorBoundary>
);
